import React, { useState, useEffect } from "react";
import { request, gql } from "graphql-request";
import { hyGraphToken, endpointURL } from "../../ThemeModule";
import { Link } from "react-router-dom";
import "./sidebar.scss";

const Sidebar = () => {
  const [categories, setCategories] = useState([]);
  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      const query = gql`
        query MyQuery {
          categories {
            title
             slug
          }
          featuredPosts: posts(where: { featuredPost: true }, first: 3) {
            title
            slug
            featureImage {
              url
            }
            categories {
              title
            }
          }
        }
      `;
      const headers = {
        Authorization: `Bearer ${hyGraphToken}`,
      };

      try {
        const data = await request(endpointURL, query, {}, headers);
        setCategories(data.categories);
        setFeaturedPosts(data.featuredPosts);
      } catch (error) {
        console.error("Error fetching posts:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  return (
    <>
      <aside className="sidebar">
        <div className="widget category">
          {loading ? (
            <div className="loader">Loading...</div>
          ) : error ? (
            <div className="error-message">
              <p>Failed to load posts: {error}</p>
            </div>
          ) : (
            <>
              <h5 className="title-widget">Categories</h5>
              <ul>
                {categories.map((category) => (
                  <li key={category.title} className="category_item">
                    <Link to={`/category/${category.slug}`}>
                      {category.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
        <div className="widget post">
          {loading ? (
            <div className="loader">Loading...</div>
          ) : error ? (
            <div className="error-message">
              <p>Failed to load posts: {error}</p>
            </div>
          ) : (
            <>
              <h5 className="title-widget">Spotlight</h5>
              <ul className="feature_post_grid">
                {featuredPosts.map((post) => (
                  <li key={post.slug} className="feature_post_item">
                    <Link to={`/blog/${post.slug}`} className="feature_post_img">
                      <img src={post.featureImage.url} alt={post.title} />
                    </Link>
                    <div className="feature_post_content">
                      <div className="post-category">
                        {post.categories.map((category) => (
                          <span key={category.title} className="">
                            {category.title}
                          </span>
                        ))}
                      </div>
                      <h4>
                        <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                      </h4>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
